import { ActionsUnion, createAction } from "../definitions";
import { DriveAPICredentialsActionTypes } from "./types";
import { ICredentials } from "../../utils/credentialsStore";
import { IIamSettings } from "../../utils/auth/iamSettings";

export interface DriveAPICredentialsActionPayload {
    userName: string;
    credentials?: ICredentials;
    server?: string;
    iamSettings?: IIamSettings;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DriveAPICredentialsActions = {
    /**
     * Set DriveAPICredentials in storage
     * @param payload Containing userId, with optional credentials and server
     */
    setUserCredentials: (payload: DriveAPICredentialsActionPayload) => createAction(DriveAPICredentialsActionTypes.SET_DRIVE_API_CREDENTIALS, payload),
    /**
     * Used to clear DriveAPICredentials from storage for specified userId
     * @param userName which DriveAPICredentials should be removed.
     */
    clearUserCredentials: (userName: string) => createAction(DriveAPICredentialsActionTypes.CLEAR_DRIVE_API_USER_CREDENTIALS, userName),
    /**
     * Used to clear DriveAPICredentials from storage
     * @param keepUsers Optional array of {@link IUser}s for which DriveAPICredentials should be kept.
     */
    clearDriveAPICredentials: (keepUsers?: IUser[]) => createAction(DriveAPICredentialsActionTypes.CLEAR_DRIVE_API_CREDENTIALS, keepUsers)
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type DriveAPICredentialsActions = ActionsUnion<typeof DriveAPICredentialsActions>;